const allSegmentsModule = {
  state: {
    items: null,
    pagination: null,
    filters_payload: null
  },
  mutations: {
    setAllsegments(state, data) {
      state.items = data
    },
    setAllsegmentsPagination(state, data) {
      state.pagination = data
    },
    setLeadsBySegmentId(state, data) {
      if(!state[data.id]) {
        state[data.id] = {
          leads: data.leads,
          pagination: data.pagination
        }
      }
      else {
        state[data.id].leads = data.leads
        state[data.id].pagination = data.pagination
      }
    },
    resetSegmentLeads(state, data) {
      if(state[data.id]) {
        delete state[data.id].leads
      }
    },
    setSegmentFilters(state, data) {
      if(!state[data.id]) {
        state[data.id] = {
          name: data.name,
          filters: data.filters
        }
      }
      else {
        state[data.id].name = data.name
        state[data.id].filters = data.filters
      }
    },
    setFiltersPayload(state, data) {
      state.filters_payload = data
    },
    addSegment(state, segment) {
      if (!state.items) {
        state.items = []
      }
      state.items.push(segment)
    }
  },
  getters: {
    getAllSegments: (state) => {
      return state.items
    },
    getAllSegmentsPagination: (state) => {
      return state.pagination
    },
    getFiltersPayload: (state) => {
      return state.filters_payload
    },
    getLeadsBySegmentId: (state) => (id) => {
      return state[id]
    },
    getSegmentById: (state) => (id) => {
      if (state[id]) {
        return state[id]
      }
      else {
        return null
      }
    },
  }
}

export default allSegmentsModule



// WEBPACK FOOTER //
// ./src/store/modules/all_segments.js